<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
>
  <!-- <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div> -->
  <div fxFlex="25%">{{ lookup?.optionTypeId }}</div>
  <div fxFlex>{{ lookup?.optionTypeName }}</div>
  <div fxFlex="15%">{{ lookup?.createdBy | createdByOrg }}</div>
  <div fxFlex="15%">{{ lookup?.dateCreated | date }}</div>
  <div fxFlex class="text-right">
    <button
      *isPermitted="{ id: 'LOOKUP_DATA_MANAGEMENT', action: 'edit' }"
      class="ui circular tiny button"
      (click)="onEdit.emit(lookup)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Edit Category"
    >
      <i class="pencil icon"></i>
    </button>
    <a
      class="ui circular tiny button"
      routerLink="/admin/setting/lookup-category/detail/{{
        lookup.optionTypeId
      }}"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="View Lookup Category Data"
    >
      <i class="eye icon"></i>
    </a>

    <!-- <button
      *isPermitted="{ id: 'LOOKUP_DATA_MANAGEMENT', action: 'remove' }"
      class="ui circular tiny button"
      (click)="onDelete.emit(lookup)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Delete Category"
    >
      <i class="trash icon"></i>
    </button> -->
  </div>
</div>
